module.exports = __webpack_public_path__ + "assets/6ead0fa76c20cbed4fdec4a7b1e108d5.png";